import { format, isWithinInterval, parseISO } from "date-fns";
import { ja } from "date-fns/locale";
import { toDateOrNull } from "../order/orderDateUpdate";
export function formatDate(date) {
  return format(date, "yyyy-MM-dd");
}

export function formatDateJpn(date) {
  return format(date, "yyyy年MM月dd日", { locale: ja });
}

export function formatDateForFilename(date) {
  return format(date, "yyyyMMdd_HHmmss");
}
export function formatTime(date) {
  return format(date, "HH:mm ss");
}

// 注文の日付(Firestore Timestamp / Date / 未設定)を一覧・カード用に整形する。
// 未設定は "—" を返す(空文字だと列が潰れて「日付が無いのか表示漏れなのか」が分からないため)。
export const formatOrderDate = (value, fallback = "—") => {
  const date = toDateOrNull(value);
  if (!date) return fallback;
  return formatDate(date);
};

// 変更履歴など、時刻まで見せたい箇所で使う
export const formatOrderDateTime = (value, fallback = "—") => {
  const date = toDateOrNull(value);
  if (!date) return fallback;
  return format(date, "yyyy-MM-dd HH:mm");
};

export const isCurrentDateWithinRange = (fromDate, toDate) => {
  // fromDate, toDate をパースして Date オブジェクトに変換
  const start = parseISO(fromDate);
  const end = parseISO(toDate);

  // 現在の日付が fromDate と toDate の間にあるかを判定
  return isWithinInterval(new Date(), { start, end });
};
